import getConfig from 'next/config';
import Script from 'next/script';
import React from 'react';

const { publicRuntimeConfig } = getConfig();

const GTM_KEY = publicRuntimeConfig?.gtmKey;

const initializeGTMEvents = () => {
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
};

// METER UM CRLH DE UMA VARIAVEL AQUI 
const GTMInjector = () => {
  return (
    <Script
      async
      strategy="afterInteractive"
      onLoad={initializeGTMEvents}
      //src={`https://dev.b-parts.com/gtm.js?id=${GTM_KEY}`}
      src={`${publicRuntimeConfig.apiHost}/m/gtm.js?id=${GTM_KEY}`}
    />
  );
};

export default function GTM() {
  if (GTM_KEY) {
    return <GTMInjector />;
  }

  return null;
}
